import React from 'react';
import { Box, Image, Button, TextButton } from '@wix/design-system';
import { CampaignData } from './CampaignData';
import { reuseCampaign } from './interactions';
import styles from './styles.scss';
export const BEST_CAMPAIGN_WIDGET = 'BEST_CAMPAIGN_WIDGET';
export const BestCampaignWidget = _ref => {
  let {
    data: {
      image,
      subject,
      status,
      sentOn,
      statistics,
      campaignId
    },
    context: {
      send,
      onWidgetAction
    }
  } = _ref;
  const logOnClick = (action, value) => {
    onWidgetAction(BEST_CAMPAIGN_WIDGET, {
      action,
      value
    });
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.inner
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "15px 18px",
    gap: 2,
    direction: "vertical",
    background: "linear-gradient(90deg, #F5F8FF 0%, #FAFCFF 30%, #F5F8FF 100%)"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.image
  }, /*#__PURE__*/React.createElement(Image, {
    src: image,
    width: 96,
    height: 136,
    borderRadius: 3,
    position: "top center"
  })), /*#__PURE__*/React.createElement(CampaignData, {
    campaignId: campaignId,
    subject: subject,
    statistics: statistics,
    status: status,
    sentOn: sentOn
  })))), /*#__PURE__*/React.createElement(Box, {
    gap: 2,
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    skin: "ai",
    onClick: () => {
      logOnClick('reuse', campaignId);
      reuseCampaign(campaignId);
    }
  }, "Reuse"), /*#__PURE__*/React.createElement(TextButton, {
    size: "tiny",
    priority: "secondary",
    weight: "normal",
    onClick: () => {
      logOnClick('find next');
      send('Can you show me another email campaign?');
    }
  }, "Show Next Campaign")));
};
//# sourceMappingURL=BestCampaignWidget.js.map